import validate from "/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/middleware/auth.ts"),
  course: () => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/middleware/course.ts")
}